import { AssistantProfile, ConfigSnapshot, DidInventoryItem, PUBLIC_VOICE_IP } from "./types";

export function generateManualConfig(
  item: Pick<
    DidInventoryItem,
    "e164" | "assigned_agent_id" | "assistant_profile" | "vendor_profile"
  >,
  now = new Date()
): ConfigSnapshot {
  const agentId = item.assigned_agent_id || "";
  const assistantType: AssistantProfile["type"] = item.assistant_profile?.type || "meydan_operator";
  const vendorHandoff =
    assistantType === "vendor_pa" || item.vendor_profile
      ? {
          purpose:
            "Give this SIP configuration to the PA vendor for this customer's ElevenLabs agent.",
          vendor_name: item.vendor_profile?.vendor_name,
          elevenlabs_account_name: item.vendor_profile?.elevenlabs_account_name,
          elevenlabs_account_owner_email: item.vendor_profile?.elevenlabs_account_owner_email,
          handoff_notes: item.vendor_profile?.handoff_notes,
          current_provider: item.vendor_profile?.current_provider,
          target_provider: "elevenlabs_sip" as const
        }
      : undefined;

  return {
    generated_at: now.toISOString(),
    version: "did-config-v1",
    e164: item.e164,
    pbx: {
      one_time_dial_patterns: [
        {
          route: "To_ElevenLabs",
          pattern: "0477776XX",
          strip: 1,
          prepend: "+971",
          scope: "one_time_range_prerequisite"
        },
        {
          route: "To_ElevenLabs",
          pattern: "+971477776XX",
          strip: 0,
          prepend: "",
          scope: "optional_e164_input"
        }
      ],
      carrier_trunk: {
        name: "Peer_047777666",
        media_ip_mode: "default_local",
        notes: "Private peer at 192.168.3.1. Do not force public SDP on this leg."
      },
      elevenlabs_trunk: {
        transport: "tls",
        port: 5061,
        host: "sip.rtc.elevenlabs.io",
        media_ip_mode: "custom_public",
        media_ip: PUBLIC_VOICE_IP,
        codec_order: ["ulaw", "alaw"],
        srtp: false,
        rtp_keepalive: true
      }
    },
    elevenlabs: {
      phone_number: item.e164,
      agent_id: agentId,
      assistant_profile_type: assistantType,
      ...(vendorHandoff ? { vendor_handoff: vendorHandoff } : {}),
      inbound_trunk_config: {
        allowed_addresses: [`${PUBLIC_VOICE_IP}/32`],
        allowed_numbers: null,
        media_encryption: "disabled"
      },
      outbound_trunk_config: {
        address: PUBLIC_VOICE_IP,
        transport: "tls",
        media_encryption: "disabled"
      }
    }
  };
}
